// extracted by mini-css-extract-plugin
module.exports = {"container":"PromotionBanner_container__LynXh"};